module.exports = __webpack_public_path__ + "static/img/10.2c6177c.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/10.png
// module id = EDm0
// module chunks = 1